import {FC, PropsWithChildren, ReactNode} from "react"
import style from './style.module.less'
import {Spin} from "antd"

type PropType = FC<PropsWithChildren<{
  footer?: ReactNode
  loading?: boolean
}>>

const DrawContainer: PropType = ({ footer, children, loading }) => {
  return (
    <div className={`h-full overflow-auto ${style.container}`}>
      <Spin spinning={!!loading}>
        {
          children
        }
      </Spin>
      {
        !!footer && (
          <div className={`text-center ${style.footer} ${!!loading && style.loading}`}>
            {
              footer
            }
          </div>
        )
      }
    </div>
  )
}

export default DrawContainer
